import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useEffect, useState } from 'react'
import ErrorList from 'src/components/ErrorList/ErrorList'
import FieldLabel from 'src/components/FieldLabel/FieldLabel'
import { css } from 'styled-components'

interface VerificationInputFieldProps {
  fieldLabel: React.ReactElement | string
  value?: string
  onChange: (value: string) => void
  placeholder: string
  className?: string
  errors?: Array<React.ReactElement | string>
  'data-testid'?: string
}

const VerificationInputField: React.FC<VerificationInputFieldProps> = (
  props,
): React.ReactElement => {
  const [showErrors, setShowErrors] = useState(props.errors !== undefined)
  useEffect((): void => {
    setShowErrors(props.errors !== undefined)
  }, [props.errors])

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    setShowErrors(false)
    props.onChange(e.target.value)
  }

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <FieldLabel>{props.fieldLabel}</FieldLabel>
      <span
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        <span
          css={css`
            margin-right: -48px;
            padding-left: 20px;
            z-index: 1;
          `}
        >
          {'EX*'}
        </span>
        <input
          css={css`
            width: 100%;
            border-radius: 6px;
            height: 50px;
            border: 1px solid ${styleConstants.colors.gray_medium};
            padding: 20px;
            padding-left: 54px;
            caret-color: ${themeConstants.colors.cta};
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            background-color: ${styleConstants.colors.gray_lightest};
            &::placeholder {
              opacity: 0.5;
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
            }
            &:focus,
            &:hover {
              background-color: ${styleConstants.colors.white};
              border: 1px solid ${themeConstants.colors.cta};
            }
          `}
          placeholder={props.placeholder}
          value={props.value}
          type={'text'}
          onChange={onChange}
          autoComplete={'off'}
          inputMode={'text'}
          maxLength={5}
          data-testid={props['data-testid']}
        />
      </span>
      {props.errors !== undefined && showErrors && (
        <ErrorList errors={props.errors} />
      )}
    </div>
  )
}

export default React.memo(VerificationInputField)
